import React from "react";
import { Grid } from "@mui/material";
import FileUpload from "../../utils/FileUpload";
import SpareImage from "../../assets/img/SpareImage.png";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import {
  DownloadErrorLogsService,
  uploadBulkSparesService,
  DownloadSparesTemplateService,
} from "../../services/BulkUploadServices";
import download from "downloadjs";
import useGlobalState from "../../../src/Context";
import { Checkbox } from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const BulkSparesUpload = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ auth }, dispatch] = useGlobalState();
  const loggedInParam = auth.ldapParam;
  const [sendNotification, setSendNotification] = React.useState(false);

  const downloadTemplate = async () => {
    try {
      setLoading(true);
      const response = await DownloadSparesTemplateService();
      const content = response.headers["content-type"];
      download(response.data, "SparesTemplate.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const downloadErrorLogs = async () => {
    try {
      setLoading(true);
      const param = {
        requestType: 2,
        id: loggedInParam.userId,
      };
      const response = await DownloadErrorLogsService(param);
      const content = response.headers["content-type"];
      download(response.data, "SpareErrorLogs.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const onFileChange = (event) => {
    if (
      event.target.files[0]?.type === "text/csv" ||
      event.target.files[0]?.type === "application/vnd.ms-excel" ||
      event.target.files[0]?.type === "application/vnd.msexcel" ||
      event.target.files[0]?.type === "application/csv" ||
      event.target.files[0]?.type === "text/comma-separated-values"
    ) {
      if (event.target.files[0].size >= 10485760) {
        showNotification(
          "Error",
          "File too Big, please select a file less than 10mb"
        );
      } else {
        uploadFile(event.target.files[0]);
      }
    } else {
      showNotification("Error", "Invalid type selected, Please try again.");
    }
  };

  const uploadFile = async (file) => {
    const bulkSpareUploadRequest = {
      createdBy: loggedInParam.userId,
      createdByName: loggedInParam.name,
      sendNotification: sendNotification,
    };
    try {
      setLoading(true);
      const uploadResponse = await uploadBulkSparesService(
        file,
        bulkSpareUploadRequest
      );
      if (uploadResponse.statusCode === 6) {
        showNotification("Success", uploadResponse.message, "success");
      } else {
        showNotification("Error", uploadResponse.message);
      }
    } catch (err) {
      showNotification("Error", "Failed To submit File");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setSendNotification(event.target.checked);
  };

  return (
    <>
      <Grid container spacing={0} sx={{ mt: 0 , pb: 0,alignItems:"center"}}>
        <Grid item xs={3} sx={{ mt: "0" }}>
          <img src={SpareImage} alt="Spare" width={60} />
        </Grid>
        <Grid item xs={4} sx={{ color: "#757575", fontSize: "16px", fontWeight: "500", mt: "0" }}>
          <p>Bulk Spares</p>
        </Grid>

        <Grid item xs={5} sx={{ mt: "0",textAlign:"left" }} >
          <FileUpload
            onFileChange={onFileChange}
            spareButton={true}
            showDownload={true}
            download={downloadTemplate}
            downloadErrors={downloadErrorLogs}
          />
        </Grid>
        <Grid sx={{ ml: 45, color: "#003f93", mb: 0, mt: -3, fontSize: "14px" }}>
          <NotificationsActiveIcon> </NotificationsActiveIcon> Send Notification
          <Checkbox
            checked={sendNotification}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BulkSparesUpload;
